module.exports = __webpack_public_path__ + "testimonials-mobile.jpg?effc2610458dc800b60f87ccb7427f84";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials-mobile.jpg
// module id = 83
// module chunks = 0